import React from "react";
import { theme } from "antd";
import { Link, useLocation } from "react-router";
import { requestCookiePreferences } from "@mealmanager/cookie-consent";
import { copyrightInceptionYear, legalCompanyDetails, legalDocumentLinks } from "@mealmanager/legal-content";

type AppFooterProps = {
  blogEnabled?: boolean;
};

const AppFooter: React.FC<AppFooterProps> = ({ blogEnabled = false }) => {
  const { token } = theme.useToken();
  const { pathname } = useLocation();
  const isHomePage = pathname === "/";
  const currentYear = new Date().getFullYear();
  const copyrightYear =
    currentYear > copyrightInceptionYear ? `${copyrightInceptionYear}-${currentYear}` : `${currentYear}`;
  return (
    <div
      style={{
        textAlign: "center",
        borderTop: "1px solid var(--ant-color-border)",
        padding: "24px",
        background: token.Layout?.footerBg,
        color: token.colorTextSecondary,
      }}
    >
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          rowGap: 8,
          columnGap: 12,
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <span style={{ whiteSpace: "nowrap", flex: "0 0 auto" }}>
          © {copyrightYear} {legalCompanyDetails.legalEntityName}
        </span>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            alignItems: "center",
            rowGap: 8,
            columnGap: 12,
            flex: "0 1 100%",
            maxWidth: "100%",
          }}
        >
          <a
            href={`mailto:${legalCompanyDetails.contactEmail}`}
            style={{
              color: token.colorPrimary,
            }}
          >
            Contact us
          </a>
          {blogEnabled && (
            <Link
              to="/blog"
              style={{
                color: token.colorPrimary,
              }}
            >
              Blog
            </Link>
          )}
          {!isHomePage && (
            <Link
              to="/#faq"
              style={{
                color: token.colorPrimary,
              }}
            >
              FAQ
            </Link>
          )}
          {legalDocumentLinks.map((link) => (
            <Link
              key={link.id}
              to={link.slug}
              style={{
                color: token.colorPrimary,
              }}
            >
              {link.label}
            </Link>
          ))}
          <button
            type="button"
            onClick={requestCookiePreferences}
            style={{
              background: "none",
              border: "none",
              padding: 0,
              color: token.colorPrimary,
              cursor: "pointer",
              font: "inherit",
            }}
          >
            Cookie preferences
          </button>
        </div>
      </div>
    </div>
  );
};

export default AppFooter;
